export const services = state => state.services.items
export const initialServices = state => {
    const initialServices = _.filter(services(state), {is_initial: true})

    return _.sortBy(initialServices, [(service) => service.title])
}
export const optionalServices = state => {
    const optionalServices = _.filter(services(state), {is_optional: true})

    return _.sortBy(optionalServices, [(service) => service.title])
}
export const serviceById = state => id => {
    return _.find(services(state), {id: parseInt(id)})
}
export const serviceNameById = state => id => {
    let service = serviceById(state)(id)
    return service ? service.title : null
}